<div>
    <app-tool-bar [title]="'Email Template'" [iconName]="'pi-envelope'" (handleAdd)="isAddTemplate = true"
        [isAdd]="true"></app-tool-bar>
</div>

<div class="p-3 overflow-y-auto h-[85vh]">
    <p-table [value]="templateData" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [(selection)]="selectedTemplates" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.sortable ? col.field : ''">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
            <tr>
                <td *ngFor="let col of displayedColumns">
                    <ng-container [ngSwitch]="col.type">

                        <ng-container *ngSwitchCase="'template_category'">
                            {{ rowData.template_category | titlecase }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'status'">
                            <span
                                [ngClass]="{ 'active_account': rowData.status === 'active', 'inactive_account': rowData.status === 'Inactive' }">
                                {{ rowData.status | titlecase }}
                            </span>
                        </ng-container>

                        <ng-container *ngSwitchCase="'actions'">
                            <div (click)="setTemplateEditData(rowData)" class="cursor-pointer min-w-[100px]">
                                <p-menu [tabindex]="undefined" #menu [model]="templateActionItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                            </div>
                        </ng-container>

                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog [modal]="true" [(visible)]="isAddTemplate" [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '90vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isAddTemplate">
        <app-create-email-template (reload)="reloadTable()"
            (closeDialog)="isAddTemplate = false"></app-create-email-template>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEditTemplate" [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '90vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isEditTemplate">
        <app-create-email-template (reload)="reloadTable()" [type]="'edit'" [templateDataToEdit]="templateToEdit"
            (closeDialog)="isEditTemplate = false"></app-create-email-template>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isPreview" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false"
    [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isPreview">
        <app-preview-email-template (closeDialog)="isPreview = false"
            [processedData]="processedData" [documents]="templateToEdit.documents"></app-preview-email-template>
    </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteTemplate" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        Delete Template

        <div class="absolute right-2">
            <button (click)="isDeleteTemplate = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="mt-2 mb-2" style="font-weight: 500; font-size: 17px; text-align: center;">
            Are you sure you want to delete this template : {{templateToEdit?.template_name}}
        </div>

        <div class="flex gap-4 mt-7 justify-end">

            <p-button label="Cancel" severity="danger" variant="outlined" (click)="isDeleteTemplate = false"></p-button>
            <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="handleDelete()"
                [disabled]="btnLoading" [loading]="btnLoading">
            </p-button>


        </div>

    </div>

</p-dialog>